<template>
	<div>
		<div>
			<button class="btn btn-dark" type="button" data-toggle="collapse" data-target="#collapseGuide" aria-expanded="false" aria-controls="collapseGuide">
				Hướng dẫn
			</button>
		</div>
		<div class="collapse" id="collapseGuide">
			<div class="card card-body border-none mt-1">
				<div>
					<h2>App xếp Lịch học FTU</h2>
					<span class="mr-2">1.</span> <b>Tải lên TKB dự kiến</b><br>
					<span class="mr-2">2.</span> <b>Nhập mã học phần</b>, chọn đúng <b>chương trình học</b><br>
					<span class="mr-2">3.</span> <b>Nhấn "Tìm lớp"</b> để hệ thống hiển thị danh sách lớp khả dụng<br>
					<span class="mr-2">4.</span> <b>Kéo-thả</b> các mã học phần vào bảng<br>
					<span class="mr-2">5.</span> <b>Hoàn tất:</b><br>
					<div class="ml-4">
						+ <b>Nhấn "Xong"</b> để lấy các mã lớp và cố định TKB<br>
						+ <b>Hoặc nhấn "Xuất file"</b> để lưu TKB đã xếp dưới dạng excel (có thể import lại và sửa sau)<br>
						+ <b>Hoặc nhấn "Lưu trong Browser"</b> để lưu tạm thời. Khi tải lại trang, chỉ cần <b>"Import TKB" <i class="fas fa-arrow-right"></i> "Nhập từ lưu trữ"</b> để khôi phục TKB đã lưu<br>
					</div>
					<br>
					<b>Video hướn dẫn: </b>
					<a href="https://youtu.be/rnzjtvPspZE" target="_blank">[Xem tại đây]</a>
					<br><br>
					<h3>Tính năng khác</h3>
					+ Trong bảng TKB, di chuột vào <b>tên lớp</b> để xem chi tiết về lớp<br>
					<div>+ Nhấn <i class="fas fa-chevron-circle-down"></i> <b>bên cạnh tên học phần</b> để xem chi tiết các lớp của học phần</div>
					<div>+ Nhấn <i class="fas fa-info-circle d-inline"></i> <b>bên cạnh mã lớp và ngày giờ</b> để xem chi tiết lớp</div>
					+ Sử dụng <b>"Import TKB"</b> để nhập TKB từ file Excel đã xuất<br>
					<br><br>
					<h4>Lưu ý:</h4>
					+ Sau khi nhấn <b>"Xong"</b>, bạn sẽ <b>không thể chỉnh sửa TKB</b> hoặc thêm mã học phần mới<br>
					+ Ứng dụng chưa hỗ trợ tự động thêm lớp kèm hoặc lớp trùng mã nhưng khác ngày<br>
					+ Một số lớp có thể <b>bị xếp chồng lên nhau</b> do cùng mã học phần và thời gian nhưng khác mã lớp hoặc chương trình học<br>
					VD: (BT, BT, LT, TN) Vật lý đại cương => 4 lớp cùng mã HP, cùng thời gian nhưng khác mã lớp, khác phòng<br>
					<br>
				</div>
			</div>
		</div>
		<!-- <div class="row my-5">
			<h4 class="col-12">Có thể bạn quan tâm:</h4>
			<div class="col-12">
				<a href="https://www.facebook.com/hieupham19072001/" :target="isTableVisible ? '_blank' : ''"><i class="fab fa-facebook mr-1"></i>Phạm Trung Hiếu ?</a>
			</div>
		</div> -->
	</div>
</template>

<script>
export default {
	props: ['isTableVisible']
}
</script>
<style scoped>
	a {
		color: #CC0000;
	}
	b {
		display: inline;
	}
</style>